// Generated by ReScript, PLEASE EDIT WITH CARE


function concatMany(l) {
  var res = l[0];
  for(var i = 1 ,i_finish = l.length; i < i_finish; ++i){
    res = res.concat(l[i]);
  }
  return res;
}

var List = {
  concatMany: concatMany
};

var $$Set = {};

export {
  List ,
  $$Set ,
  
}
/* No side effect */
